import { combineReducers } from 'redux';
import { routerReducer } from 'react-router-redux';
import { reducer as searchReducer } from 'redux-search';
import { reducer as formReducer } from 'redux-form';

import horsesReducer from './horsesReducer';
import salesReducer from './salesReducer';
import flashMessageReducer from './flashMessageReducer';
import currentUserReducer from './currentUserReducer';
import horseLightboxReducer from './horseLightboxReducer';
import sortReducer from './sortReducer';
import updatesReducer from './updatesReducer';
import activeApiCalls from './activeApiCalls';
import statsReducer from './statsReducer';
import suggestionSearchActive from './suggestionSearchActive';

const rootReducer = combineReducers({
    routing: routerReducer,
    currentUser: currentUserReducer,
    sale: salesReducer,
    horses: horsesReducer,
    horseLightbox: horseLightboxReducer,
    flashMessage: flashMessageReducer,
    search: searchReducer,
    form: formReducer,
    sort: sortReducer,
    updates: updatesReducer,
    previousSaleStats: statsReducer,
    activeApiCalls,
    suggestionSearchActive,
});

export default rootReducer;
